import styled from "styled-components";
import Chip from '@material-ui/core/Chip';

export const ChipCustom = styled(Chip)`
    margin-left: 7px;
`;